import React from "react";

const CommonFormFields = ({ formData, handleInputChange, errors }) => {
  return (
    <div>
      <div className="form-box mt-4">
        <div className="form-item">
          <label htmlFor="firstname">First Name</label>
          <input
            type="text"
            id="firstname"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
          />
          {errors.firstName && <span className="error">{errors.firstName}</span>}
        </div>
        <div className="form-item">
          <label htmlFor="lastname">Last Name</label>
          <input
            type="text"
            id="lastname"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
          />
          {errors.lastName && <span className="error">{errors.lastName}</span>}
        </div>
      </div>

      <div className="form-box mt-5">
        <div className="form-item">
          <label htmlFor="mobilenumber">Mobile Number</label>
          <input
            type="text"
            id="mobilenumber"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleInputChange}
          />
          {errors.mobileNumber && <span className="error">{errors.mobileNumber}</span>}
        </div>
        <div className="form-item">
          <label htmlFor="wtnumber">WhatsApp Number</label>
          <input
            type="text"
            id="wtnumber"
            name="wtNumber"
            value={formData.wtNumber}
            onChange={handleInputChange}
          />
          {errors.wtNumber && <span className="error">{errors.wtNumber}</span>}
        </div>
      </div>

      <div className="form-box1 mt-5">
        <div className="form-item">
          <label htmlFor="email">Email Address</label>
          <input
            type="text"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
      </div>
    </div>
  );
};

export default CommonFormFields;